<div class="spacing--padding-all spacing--margin-all" data-test="animal-group">
  <ng-container>
    <agr-table
      [config]="tableConfigBarnMapping"
      [enableStepArrows]="false"
      [emptyTitle]=""
      [emptyDescription]=""
      emptyImage=""
      [isEmpty]="false"
    ></agr-table>
    <br />
  </ng-container>

  <!-- SwitchDay Table -->
  <agr-summary-card
    [title]="'animal-group.switchDay' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="true"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <button
        mat-flat-button
        color="primary"
        (click)="openSwitchDaySlideIn()"
        data-test="switchDay__add"
      >
        <mat-icon>add</mat-icon>{{ 'animal-group.addSwitchDay' | translate }}
      </button>
    </ng-container>

    <agr-table [config]="tableConfigSwitchDay" [emptyTitle]="" [emptyDescription]=""></agr-table>
  </agr-summary-card>

  <!-- Medication Table -->

  <agr-summary-card
    [title]="'animal-group.medication' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="true"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <button
        mat-flat-button
        color="primary"
        (click)="openMedicationSlideIn()"
        data-test="medication__add"
      >
        <mat-icon>add</mat-icon>{{ 'animal-group.addMedication' | translate }}
      </button>
    </ng-container>

    <agr-table [config]="tableConfigMedication" [emptyTitle]="" [emptyDescription]=""></agr-table>
  </agr-summary-card>

  <!-- Vaccination Table -->

  <agr-summary-card
    [title]="'animal-group.vaccination' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="true"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <button
        mat-flat-button
        color="primary"
        (click)="openVaccinationSlideIn()"
        data-test="vaccination__add"
      >
        <mat-icon>add</mat-icon>{{ 'animal-group.addVaccination' | translate }}
      </button>
    </ng-container>

    <agr-table [config]="tableConfigVaccination" [emptyTitle]="" [emptyDescription]=""></agr-table>
  </agr-summary-card>
</div>
